const DashboardPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center">
      <img 
        src="/maintenance-illustration.svg"
        alt="maintenance"
        className="h-64 w-auto"
      />
      <h1 className="text-4xl font-bold uppercase text-main-blue">Under Construction</h1>
      <p className="text-main-blue mt-1">
        This page is under construction.
      </p>
    </div>
  )
}

export default DashboardPage